.focusedDate {
  padding-bottom: 15px;
  text-align: center;
}

.focusedDayTxt {
  color: var(--color-txt-primary);
  font-family: var(--brand-day-font-family);
  font-size: var(--brand-day-date-font-size);
  letter-spacing: 0.8px;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
}

.focusedDateTxt {
  color: var(--color-txt-primary);
  font-family: var(--brand-date-font-family);
  font-size: var(--brand-day-date-font-size);
  line-height: 16px;
}
.swipeRight {
  animation: swipeRight 0.3s forwards;
}

.swipeLeft {
  animation: swipeLeft 0.3s forwards;
}

.enterRight {
  animation: enterRight 0.3s forwards;
}

.enterLeft {
  animation: enterLeft 0.3s forwards;
}

@keyframes swipeRight {
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(10%);
    opacity: 0;
  }
}

@keyframes swipeLeft {
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(10%);
    opacity: 0;
  }
}

@keyframes enterRight {
  0% {
    transform: translateX(-10%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes enterLeft {
  0% {
    transform: translateX(-10%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}
